import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommercialAgreementState } from './commercial-agreements/commercial-agreement.store';
import { CustomerGroup } from './customer-group.interface';
import { CustomerGroupService } from './customer-group.service';

const service = new CustomerGroupService();

export interface CustomerGroupState {
   customerGroupsOverview?: PaginatedResponse<CustomerGroup>;

   // sub-modules
   commercialAgreement?: CommercialAgreementState;
}

const CustomerGroupStore: Module<CustomerGroupState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_CUSTOMER_GROUPS(state, overview: PaginatedResponse<CustomerGroup>) {
         state.customerGroupsOverview = overview;
      },
      ADD_CUSTOMER_GROUP(state, customerGroup: CustomerGroup) {
         state.customerGroupsOverview?.data.push(customerGroup);
         state.customerGroupsOverview!.total += 1;
      },
      CHANGE_CUSTOMER_GROUP(state, customerGroup: CustomerGroup) {
         const index = (state.customerGroupsOverview?.data || []).findIndex((cg) => cg.id === customerGroup.id);
         if (index > -1) state.customerGroupsOverview?.data.splice(index, 1, customerGroup);
      },
      DELETE_CUSTOMER_GROUP(state, customerGroupId: number) {
         const index = (state.customerGroupsOverview?.data || []).findIndex((cg) => cg.id === customerGroupId);
         if (index > -1) state.customerGroupsOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async searchCustomerGroups(context, query?: LocationQuery) {
         return service.getCustomerGroups(query);
      },
      async getCustomerGroups(context, query?: LocationQuery) {
         const response = await service.getCustomerGroups(query);
         context.commit('SET_CUSTOMER_GROUPS', response);
         return response;
      },
      async getCustomerGroup(context, payload: { customerGroupId: number; query?: LocationQuery }) {
         return await service.getCustomerGroup(payload.customerGroupId, payload.query);
      },
      async createCustomerGroup(context, customerGroup: CustomerGroup) {
         const response = await service.postCustomerGroup(customerGroup);
         context.commit('ADD_CUSTOMER_GROUP', response);
         return response;
      },
      async changeCustomerGroup(context, payload: { customerGroup: CustomerGroup; customerGroupId: number; query?: LocationQuery }) {
         const response = await service.putCustomerGroup(payload.customerGroupId, payload.customerGroup, payload.query);
         context.commit('CHANGE_CUSTOMER_GROUP', response);
         return response;
      },
      async deleteCustomerGroup(context, customerGroupId: number) {
         const response = await service.deleteCustomerGroup(customerGroupId);
         context.commit('DELETE_CUSTOMER_GROUP', customerGroupId);
         return response;
      },
   },
};

export default CustomerGroupStore;
